import ExploreView from './ExploreView.vue';

export const exploreRoutes = [
    {
        path: '/explore',
        name: 'Explore',
        component: ExploreView,
        meta: {
            requiresAuth: true,
            accessId: 'explore',
        }
    }
]

